import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import SituationCard from '@components/chat/SituationCard';
import { PaginationIterator } from '@components/common/Pagination';

import { IChatPagination, IChatSituationInfo } from '@model';
import { UsePaginationQueryResult } from '@utils/query';

const situationContainerCSS = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0 ${Spacing.medium}px;
  column-gap: ${Spacing.small}px;
  row-gap: ${Spacing.xlarge}px;
  margin-top: ${Spacing.medium}px;
`;

interface SituationListProps {
  query: UsePaginationQueryResult<IChatPagination<IChatSituationInfo>>;
  handleSituationCardClick: (id: number) => void;
}

const SituationList = ({
  query,
  handleSituationCardClick,
}: SituationListProps) => {
  return (
    <PaginationIterator
      name="character-situation-list"
      query={query}
      ad={false}
      css={situationContainerCSS}
    >
      {(item) => (
        <SituationCard
          situation={item}
          onCardClick={handleSituationCardClick}
        />
      )}
    </PaginationIterator>
  );
};

export default SituationList;
